import React from 'react';
import { Alert, Box, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useErrorContext } from '../../contexts/ErrorContext';

export function ErrorOverlay() {
  const { errors, clearError } = useErrorContext();
  const entries = Object.entries(errors);
  if (entries.length === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 72,
        right: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        zIndex: 1500,
        maxWidth: 420,
      }}
    >
      {entries.map(([key, message]) => (
        <Alert
          key={key}
          severity="error"
          variant="filled"
          action={(
            <IconButton
              size="small"
              aria-label="Fehler schließen"
              onClick={() => clearError(key)}
              sx={{ color: 'inherit' }}
            >
              <Close fontSize="small" />
            </IconButton>
          )}
        >
          {message}
        </Alert>
      ))}
    </Box>
  );
}
